// agents/src/components/Layout.jsx
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { isAdmin } from '../utils/auth';

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);
  const admin = isAdmin();

  return (
    <div style={styles.container}>
      {/* Navbar Vertical */}
      <div style={styles.navbar}>
        <button
          style={{
            ...styles.navButton,
            ...(isActive('/dashboard') ? styles.activeNavButton : {})
          }}
          onClick={() => navigate('/dashboard')}
          title="Buzón"
        >
          📥
        </button>
        {admin && (
          <button
            style={{
              ...styles.navButton,
              ...(isActive('/admin') ? styles.activeNavButton : {})
            }}
            onClick={() => navigate('/admin')}
            title="Admin"
          >
            📊
          </button>
        )}
        <button
          style={{
            ...styles.navButton,
            ...(isActive('/settings') ? styles.activeNavButton : {})
          }}
          onClick={() => navigate('/settings')}
          title="Ajustes"
        >
          ⚙️
        </button>
      </div>

      {/* Contenido Principal */}
      <div style={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
  },
  navbar: {
    width: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem 0',
    gap: '1rem',
    background: '#F0F5FF',
    borderRight: '1px solid #BDD6FF',
    flexShrink: 0,
  },
  navButton: {
    width: '40px',
    height: '40px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '1.5rem',
    borderRadius: '8px',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#3A3F46'
  },
  activeNavButton: {
    color: '#1A6EFF',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
};
